import axiosBase from "../../utils/axios/axios";

export const postResumen = async (data) => {
    try {
        const response = await axiosBase.post("Solicitud_creada/solicitudes/", data);
        return response.data;
    } catch (error) {
        throw error;
    }
}